/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
window.addEventListener("load", function() { 
var addToCartPopup = document.getElementById('add-to-cart');

/* theme fix for homepage slider */
(function() {
  var touchingCarousel = false,
      touchStartCoords;

  document.body.addEventListener('touchstart', function(e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function(e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

      }, {passive: false});
})();


/*To Hide the swatches which are marked as discontinued */
jQuery('.discontinued').each(function(){
  jQuery('body').append('<style>.swatch-view-item:nth-child('+(jQuery(this).index()+1)+'){ display:none;}</style>');
});

/* To fix css of promo product in two column layout in collection page */
jQuery('.CollectionToolbar__LayoutType').on('click',function(){

  if(jQuery(this).attr('data-count') == 1) {

    jQuery('.plppromo').addClass('singlelayout');
    jQuery('.plppromo').removeClass('doublelayout');

  }
  if(jQuery(this).attr('data-count') == 2) {

    jQuery('.plppromo').removeClass('singlelayout');
    jQuery('.plppromo').addClass('doublelayout');
  }

});
  /* To append swatch title to the product title in Lipstick promo popup */
jQuery('.ProductItem__ColorSwatchItem').on('click',function(){
  var swatchTitle = jQuery(this).find('.ColorSwatch').attr('data-tooltip');
  var orgTitle = jQuery(this).parent().prev().prev().find('a').html();
  jQuery(this).parent().prev().prev().find('a').find('.swatch-title').html(" - "+swatchTitle);
  jQuery(this).parent().parent().parent().next().find('button').attr('variant-id',jQuery(this).attr('variant-swatch-id'));
});
});


/* MMM add to cart script start */
window.addEventListener("message", receiveMessage, false);
function receiveMessage(event) {
  if (event.origin !== "http://stage.matchmymakeup.com" && event.origin !== "https://www.matchmymakeup.com")
    return;

  var messageObject = event.data;
  if (messageObject.event_id === 'add_to_cart') {
    jQuery.colorbox.close();
    var name = messageObject.product.productName;
    var pageShadeHandle = $("ul").find("[orig-value='" + name + "']");

    if (pageShadeHandle.length > 0){
      pageShadeHandle.trigger("click");
      $("form").find("[data-action='add-to-cart']").trigger("click");
    }

  }
}
/* MMM add to cart script end */
/* To cycle the messages shown in AnnouncementBar */
/* var text = ["Free Sample with every order.","<strong>Your Gift:</strong> Receive 9-Piece Gift With Any Purchase $149+", "Beauty Now, Pay Later. Shop With Afterpay.", "Free shipping within Australia on orders $75 and over."]; */
var text = ["Free shipping with every order.","Free Sample with every order.", "Beauty Now, Pay Later. Shop With Afterpay."];
var counter = 0;
var elem = document.getElementsByClassName("AnnouncementBar__Content")[0];
var inst = setInterval(change, 5000);

function change() {
  if(elem) {  
    elem.innerHTML = text[counter];
    counter++;
    if (counter >= text.length) {
      counter = 0;
      // clearInterval(inst); // uncomment this if you want to stop refreshing after one cycle
    }
  }
}
